import { render, staticRenderFns } from "./index.vue?vue&type=template&id=26b1b7b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b1b7b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26b1b7b4')) {
      api.createRecord('26b1b7b4', component.options)
    } else {
      api.reload('26b1b7b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=26b1b7b4&scoped=true", function () {
      api.rerender('26b1b7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybbniotdb/index.vue"
export default component.exports